module.exports = __webpack_public_path__ + "static/img/sangdi3.7780b046.jpg";